import * as apiOperations from '@/network/api/operations/operations.api.js'
import * as apiAccounts from '@/network/api/accounts.api.js'
import * as smartTransfers from '@/network/api/smartTransfers.api.js'
import * as terms from '@/network/api/terms.api.js'
import * as cardsCredit from '@/network/api/cards/credit.api.js'
import * as payments from '@/network/api/payments/payments.api.js'
import * as mobilePayments from '@/network/api/mobilePayments.api.js'
import * as batchfile from '@/network/api/batchfile.api.js'

/** Generate a link to share a pdf without the need to send the file
@payload {Object}
@return {promise} - generate share link request
*/
export const generateShareLink = async (context, payload) => {
    const res = await apiOperations.generateShareLink(payload)
    return res
}

/** Sends a notification to email
@payload {Object}
@return {promise} - send notification to email request
*/
export const sendOperationEmailNotification = async (context, payload) => {
    const res = await apiOperations.sendOperationEmailNotification(payload)
    return res
}

/** Sends a notification to sms
@payload {Object}
@return {promise} - send notification to sms request
*/
export const sendOperationSMSNotification = async (context, payload) => {
    const res = await apiOperations.sendOperationSMSNotification(payload)
    return res
}

/** Sends bulk notification to email
@payload {Object} - {
    operationIds: Array,
    email: email that will receive the notification
}
@return {promise} - send bulk notification to email request
*/
export const sendBulkOperationEmailNotification = async (context, payload) => {
    const res = await apiOperations.sendBulkOperationEmailNotification(payload)
    return res
}

/** Sends bulk notification to sms
@payload {Object} - {
    operationIds: Array,
    phoneNumber: phoneNumber that will receive the notification
}
@return {promise} - send notification to sms request
*/
export const sendBulkOperationSMSNotification = async (context, payload) => {
    const res = await apiOperations.sendBulkOperationSMSNotification(payload)
    return res
}

/** Sends movement notification to email
@payload {Object} - {
    operationId: movementId,
    accountId: id,
    data: { email: email that will receive the notification }
    params: { movementTransferType: id, releaseDatePosition: string date, orderNumberPosition: number }
}
@return {promise} - send movement notification to email request
*/
export const sendMovementEmailNotification = async (context, payload) => {
    const res = await apiAccounts.sendMovementEmailNotification(payload)
    return res
}

/** Sends movement notification to sms
@payload {Object} - {
    operationId: movementId,
    accountId: id,
    data: { receiver: phoneNumber that will receive the notification }
    params: { movementTransferType: id, releaseDatePosition: string date, orderNumberPosition: number }
}
@return {promise} - send movement notification to email request
*/
export const sendMovementSMSNotification = async (context, payload) => {
    const res = await apiAccounts.sendMovementSMSNotification(payload)
    return res
}

/**
* payload
* @params { operationId: accountId, receiver: email that will receive the notification }
*/
export const sendNbaIbanEmailNotification = async (context, payload) => {
    const res = await apiAccounts.sendNbaIbanEmailNotification(payload)
    return res
}
/**
* payload
* @params { operationId: id, receiver: phoneNumber that will receive the notification }
*/
export const sendNbaIbanSMSNotification = async (context, payload) => {
    const res = await apiAccounts.sendNbaIbanSMSNotification(payload)
    return res
}

/**
* payload
* @params { operationId: id, receiver: email that will receive the notification }
*/
export const sendSmartTransferSubmissionEmailNotification = async (context, payload) => {
    const res = await smartTransfers.sendSmartTransferSubmissionEmailNotification(payload)
    return res
}
/**
* payload
* @params { operationId: id, receiver: phoneNumber that will receive the notification }
*/
export const sendSmartTransferSubmissionSmsNotification = async (context, payload) => {
    const res = await smartTransfers.sendSmartTransferSubmissionSmsNotification(payload)
    return res
}

/**
* payload
* @params { operationId: id, receiver: email that will receive the notification }
*/
export const sendTermsEmailNotification = async (context, payload) => {
    const res = await terms.sendTermsEmailNotification(payload)
    return res
}
/**
* payload
* @params { operationId: id, receiver: phoneNumber that will receive the notification }
*/
export const sendTermsSMSNotification = async (context, payload) => {
    const res = await terms.sendTermsSMSNotification(payload)
    return res
}

/**
* payload
* @params { operationId: accountId, receiver: email that will receive the notification }
*/
export const sendFlexTransferEmailNotification = async (context, payload) => {
    const res = await cardsCredit.sendFlexTransferEmailNotification(payload)
    return res
}
/**
* payload
* @params { operationId: id, receiver: phoneNumber that will receive the notification }
*/
export const sendFlexTransferSMSNotification = async (context, payload) => {
	const res = await cardsCredit.sendFlexTransferSMSNotification(payload)
    return res
}

/**
* payload
* @params { operationId: id, receiver: email that will receive the notification }
*/
export const sendPaymentEmailNotification = async (context, payload) => {
    const res = await payments.sendPaymentEmailNotification(payload)
    return res
}
/**
* payload
* @params { operationId: id, receiver: phoneNumber that will receive the notification }
*/
export const sendPaymentSMSNotification = async (context, payload) => {
	const res = await payments.sendPaymentSMSNotification(payload)
    return res
}

/**
* payload
* @params { operationId: id, receiver: email that will receive the notification }
*/
export const sendMobilePaymentEmailNotification = async (context, payload) => {
    const res = await mobilePayments.sendMobilePaymentEmailNotification(payload)
    return res
}
/**
* payload
* @params { operationId: id, receiver: phoneNumber that will receive the notification }
*/
export const sendMobilePaymentSmsNotification = async (context, payload) => {
	const res = await mobilePayments.sendMobilePaymentSmsNotification(payload)
    return res
}

/**
* payload
* @params { operationId: id, receiver: email that will receive the notification }
*/
export const sendBatchfileEmailNotification = async (context, payload) => {
    const res = await batchfile.sendBatchfileEmailNotification(payload)
    return res
}
/**
* payload
* @params { operationId: id, receiver: phoneNumber that will receive the notification }
*/
export const sendBatchfileSMSNotification = async (context, payload) => {
	const res = await batchfile.sendBatchfileSMSNotification(payload)
    return res
}
/**
* payload
* @params { operationId: id, receiver: phoneNumber that will receive the notification }
*/
export const sendBatchfileXLSEmail = async (context, payload) => {
	const res = await batchfile.sendBatchfileXLSEmail(payload)
    return res
}

export const sendBatchfileEntryEmailNotification = async (context, payload) => {
    const res = await batchfile.sendBatchfileEntryEmailNotification(payload)
    return res
}

export const sendBatchfileEntrySMSNotification = async (context, payload) => {
    const res = await batchfile.sendBatchfileEntrySMSNotification(payload)
    return res
}

/**
* payload
* @params { contacs: [{ name, msisdn}] }
*/
export const contacts = async (context, payload) => {
    const res = await smartTransfers.contacts(payload)
    return res
}
